import { Ng1StateDeclaration } from '@uirouter/angularjs';

import * as Resolve from '../Resolve';
import { Roles } from '../../common/constants';

const states: Ng1StateDeclaration[] = [{
    component: 'wtReloadCache',
    name: 'reloadCache',
    url: '/reloadCache',
    resolve: {
        auth: Resolve.authResolve,
        roles: Resolve.rolesResolve([Roles.superAdministrator, Roles.administrator, Roles.master, Roles.engineer])
    },
    abstract: false,
    data: {
        visible: true,
        sortingOrder: 0,
        icon: '',
        displayName: 'Reload cache',
        editButtonVisibility: () => false
    }
}];

export default states;